module.exports = "/assets/site/images/futo.jpg?d49bb75eac66fab9b2a5bd0b27e971cd";